export const SetMode = 'SET_MODE';
export const SetResolution = 'SET_PREVIEW_RESOLUTION';
export const showLoadingIndicator = 'SHOW_LOADER_INDICATOR';
export const hideLoadingIndicator = 'HIDE_LOADER_INDICATOR';